'use client';

import '@ui5/webcomponents/dist/FileUploader.js';
import { ValueState } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `FileUploader` opens a file explorer dialog and enables users to upload files. The component consists of input field, but you can provide an HTML element by your choice to trigger the file upload, by using the default slot. Furthermore, you can set the property "hideInput" to "true" to hide the input field.
 * To get all selected files, you can simply use the read-only "files" property. To restrict the types of files the user can select, you can use the "accept" property.
 * And, similar to all input based components, the FileUploader supports "valueState", "placeholder", "name", and "disabled" properties. For the `FileUploader`
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-FileUploader)
 */
const FileUploader = withWebComponent('ui5-file-uploader', ['accept', 'name', 'placeholder', 'value', 'valueState'], ['disabled', 'hideInput', 'multiple'], ['valueStateMessage'], ['change']);
FileUploader.displayName = 'FileUploader';
FileUploader.defaultProps = {
  valueState: ValueState.None
};
export { FileUploader };